import { useTranslation } from 'react-i18next';

const StepProgress = ({ currentStep }) => {
    const { t } = useTranslation();

    const steps = [
        t('registerStep1'),
        t('registerStep2'),
        t('registerStep3')
    ];

    return (
        <div className="w-full max-w-3xl mx-auto pt-5">
            <div className="flex justify-between items-center mb-10 mt-5">
                {steps.map((_, index) => {
                    const step = index + 1;
                    const isActive = currentStep === step;
                    const isCompleted = currentStep > step;

                    return (
                        <div key={index} className="w-1/3 flex justify-center">
                            <div className={`w-5 h-5 lg:w-7 lg:h-7 lg:mb-7 rounded-full flex items-center justify-center text-sm font-semibold ${isCompleted ? 'bg-green-500' : isActive ? 'bg-blue-600' : 'bg-gray-400'}`}>
                                {/* {step} */}
                            </div>
                        </div>
                    );
                })}
            </div>

            <h1 className="lg:text-3xl text-xl text-center font-bold lg:my-4 mx-2 text-gray-700 pb-2">
                {steps[currentStep - 1]}
            </h1>
            {currentStep === 1 && <h1 className="text-center text-gray-700 pb-2 mx-4">{t('registerStep1Info')}</h1>}
            {/* {currentStep === 2 && <h1 className="text-center text-gray-700 pb-2 mx-4">{t('registerStep2Info')}</h1>} */}
            {currentStep === 3 && <h1 className="text-center text-gray-700 pb-2 mx-4">{t('registerStep3Info')}</h1>}
        </div>
    );
};

export default StepProgress;
